export const codeSelectorTranslations = {
  back: 7518,
  reports_company: 5330,
  select_case_type: 7431,
  change_case_type: 3717,
  change_case_type_info_message: 3878,
  dashboards: 6779,
  codetable_administration: 8268,
  no_access_to_codetable_administration: 8320,
  search: 7345,
  no_results: 8617
};

export type CodeSelectorTranslation = {
  readonly [T in keyof typeof codeSelectorTranslations]: string
};
